import {Ajax} from '../helpers/ajax';
import {ElementHelpers} from '../helpers/element-helpers';

export class SearchJobcount {

	constructor(elem) {
		this.elem = elem;
		this.endpoint = this.elem.dataset.searchJobcount;
		this.counterContainer = this.elem.querySelector('[data-jobcount');
		this.originalCounter = this.counterContainer.innerHTML;
		this.inputs = this.elem.querySelectorAll('input');
		this.jobboardUrl = this.elem.dataset.jobboardUrl;

		this.buttonString = this.elem.querySelector('[data-buttonstring]');
		this.buttonStringSingle = this.elem.dataset.buttonstringSingle || 'vacature';
		this.buttonStringMultiple = this.elem.dataset.buttonstringMultiple || 'vacatures';

		this.init();
	}

	/**
	 * Initializes the jobSearch
	 */
	init() {
		this.addEventListeners();
	}

	/**
	 * Adds all necessary event listeners
	 */
	addEventListeners() {
		ElementHelpers.addEventListeners(this.inputs, 'change', () => {
			this.onChangeInput();
		});

		this.elem.addEventListener('submit', (e) => {
			e.preventDefault();
			window.location.href = this.jobboardUrl + this.getQueryParams();
		})
	}

	/**
	 * Handles onchange textinput
	 */
	onChangeInput() {
		if (this.isEmpty()) {
			this.counterContainer.innerHTML = this.originalCounter;
		} else {
			const query = this.getQueryParams();
			this.fetchAmount(query);
		}
	}

	/**
	 * Sets query parameters for the AJAX request
	 * @returns {string}
	 */
	getQueryParams() {
		let query = '?';
		for (let i = 0; i < this.inputs.length; i++) {
			const input = this.inputs[i];
			const inputName = input.name || '';
			const inputValue = input.value || '';
			if (inputName && inputValue) query += `${inputName}=${inputValue}&`;
		}
		query = query.substring(0, query.length - 1);
		return query;
	}

	/**
	 * Fetches the data from the rest endpoint
	 * @param query
	 */
	fetchAmount(query) {
		Ajax.GET(this.endpoint + query).then((response) => {
			this.counterContainer.innerHTML = response;
			this.buttonString.innerHTML = response === 1 ? this.buttonStringSingle : this.buttonStringMultiple;
		});
	}

	/**
	 * Checks if textinput fields are empty
	 * @returns {boolean}
	 */
	isEmpty() {
		for (let i = 0; i < this.inputs.length; i++) {
			const input = this.inputs[i];
			if (input.type === 'text' && input.value !== '') {
				return false;
			}
		}
		return true;
	}

	static getSelector() {
		return '[data-search-jobcount]';
	}
}
